const protocolRx = /^(\w+:)?(\/\/)?/

module.exports = function normalizeHttpUri(input) {
  if (!input) {
    return ''
  }
  const matches = input.match(protocolRx)
  const protocol = matches && matches[1] ? matches[1] + (matches[2] || '') : 'http://'
  return input.replace(protocolRx, protocol)
}
